import { SubscriptionState } from './state';

export const subscriptionInitialState: SubscriptionState = {
  invoices: [],
  subscriptionCreated: false,
  label: {},
};
